import React, { useContext, useState } from 'react';
import Icon, { Icons } from '@shared/Icons/Icon';
import DiscoveryContext from '../../../../../../../contexts/discoveryContext/contextV2';
import AppContext from '../../../../../../../context';
import { AccuracyEnum } from '../../../../../../../appContext/location';
import { ContextName } from '../../../../../../../appContext/contextName';
import { getSearchParamsFromLocation } from '../../../../../provider/location';
import { getBrowserLocation } from '../../../../../../../appContext/LocationProvider';
import {
  container,
  imageContainer,
  textContainer,
  title as titleStyle,
} from './styles.module.css';

const NearMe = ({ forceConfirm }) => {
  const {
    [ContextName.LOCATION.LATITUDE]: latitude,
    [ContextName.LOCATION.LONGITUDE]: longitude,
    [ContextName.LOCATION.NAME]: locationName,
    [ContextName.LOCATION.ACCURACY]: locationAccuracy,
    [ContextName.LOCATION.UPDATE_COORDS]: updateCoords,
    [ContextName.LOCATION.UPDATE_NAME]: updateLocationName,
    [ContextName.LOCATION.BROWSER_GEO_QUERYABLE]: browserGeoQueryable,
    [ContextName.LOCATION
      .UPDATE_BROWSER_GEO_QUERYABLE]: updateBrowserGeoQueryable,
  } = useContext(AppContext);
  const { pushHistory } = useContext(DiscoveryContext);
  const [isLoadingGeo, setIsLoadingGeo] = useState(false);

  if (!browserGeoQueryable || !latitude || !longitude) {
    return null;
  }

  const onClick = async () => {
    if (locationAccuracy !== AccuracyEnum.BROWSER) {
      try {
        setIsLoadingGeo(true);

        const {
          locationName: updatedLocationName,
          latitude: updatedLatitude,
          longitude: updatedLongitude,
          accuracy,
        } = await getBrowserLocation();

        updateCoords({ latitude: null, longitude: null });
        updateCoords({
          latitude: updatedLatitude,
          longitude: updatedLongitude,
          accuracy,
        });
        updateLocationName({ locationName: updatedLocationName });

        const params = getSearchParamsFromLocation({
          name: updatedLocationName,
          point: {
            lat: updatedLatitude,
            lng: updatedLongitude,
            radius: 50,
          },
        });

        pushHistory(params);
        forceConfirm();
      } catch {
        updateBrowserGeoQueryable(false);
      }
    } else {
      const params = getSearchParamsFromLocation({
        name: locationName,
        point: {
          lat: latitude,
          lng: longitude,
          radius: 50,
        },
      });

      pushHistory(params);
      forceConfirm();
    }
  };

  const shouldShowLocationName =
    locationName && locationAccuracy === AccuracyEnum.BROWSER;

  const title = isLoadingGeo
    ? 'Loading...'
    : `Near me${shouldShowLocationName ? ` in ${locationName}` : ''}`;

  return (
    <div className={container} onClick={onClick} onKeyPress={onClick}>
      <div className={imageContainer}>
        <Icon icon={Icons.LOCATION_PIN.GREY} />
      </div>
      <div className={textContainer}>
        <span className={titleStyle}>{title}</span>
      </div>
    </div>
  );
};

export default NearMe;
